import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivityService } from '../../services/activity-services';
import { Activity } from 'src/app/model/Avtivity';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivityType } from 'src/app/model/activityType';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { Location } from '@angular/common';
import { PresenceCodeView } from '../models/presence-code-view.model';
// ===== DÉBUT AJOUT : popup « Détails de l'activité » =====
import { ActivityResponse } from 'src/app/model/dto/ActivityResponse';
import { LieuDTO } from 'src/app/model/dto/activity-session';
import { ImpactSuppression } from '../models/Impact-suppression.model';
// ===== FIN AJOUT =====

@Component({
  selector: 'app-agenda',
  templateUrl: `./agenda.component.html`,
  styleUrls: ['./agenda.component.css'],
})
export class AgendaComponent implements OnInit {
  listActivity!: Activity[];
  activities!: Activity[];

  showSpinner!: boolean;
  showDetails: boolean = false;
  showDeleteModal = false;
  activityToDelete: any = null;
  activityIdToDelete: number | null = null;
  activity: any;
  dataSource = new MatTableDataSource<Activity>();

  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  showModalClosure: boolean = false;
  activityToToggle: any = null;

  // Variables pour la pagination côté serveur
  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  totalPages = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'details',
    'confirmation',
    'participants',
    'actions',
  ];
  pipe!: DatePipe;

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
    byType: new FormControl(),
    // ===== DÉBUT AJOUT : filtre par pays ('' = tous) =====
    byCountry: new FormControl(''),
    // ===== FIN AJOUT =====
  });
  get fromDate() {
    return this.filterForm.get('fromDate')?.value;
  }
  get toDate() {
    return this.filterForm.get('toDate')?.value;
  }
  get byType() {
    return this.filterForm.get('byType')?.value;
  }

  // ===== DÉBUT AJOUT : pays envoyé au back ('' ou null = tous → undefined) =====
  get byCountry(): string | undefined {
    return this.filterForm.get('byCountry')?.value || undefined;
  }
  // ===== FIN AJOUT =====

  profil!: any;

  user!: any;

  activityType!: any[] | undefined;

  // ===== MODIF : message affiché dans un bandeau (le booléen error n'était affiché nulle part) =====
  erreurListe: string | null = null;
  private erreurListeTimer?: ReturnType<typeof setTimeout>;
  // ===== AJOUT : message de succès (suppression, fermeture) =====
  succesListe: string | null = null;
  private succesListeTimer?: ReturnType<typeof setTimeout>;
  showModalQRCode: boolean = false;
  qrCodeUrl!: string;

  role!: any;
  nomrole!: string;
  loading = false;
  rowDATA: any;

  isAtelierForcen: boolean = false;

  isFinanceBenin: boolean = false;
  copiedRowId: number | null = null;
  // ===== DÉBUT AJOUT : filtre par pays =====
  readonly PAYS_FILTRE = [
    { code: '', libelle: 'Tous' },
    { code: 'sn', libelle: 'Sénégal' },
    { code: 'bj', libelle: 'Bénin' },
  ];

  choisirPaysFiltre(code: string): void {
    this.filterForm.get('byCountry')?.setValue(code);
  }

  // "?? ''" : après un filterForm.reset(), la valeur vaut null → on la traite comme "Tous"
  paysFiltreActif(code: string): boolean {
    return (this.filterForm.get('byCountry')?.value ?? '') === code;
  }

  get nbFiltresActifs(): number {
    const v: any = this.filterForm.value; // ← MODIF : "any" car on lit les champs par leur nom
    return ['fromDate', 'toDate', 'byType', 'byCountry'].filter((k) => !!v[k])
      .length;
  }
  // ===== FIN AJOUT =====

  private readonly TYPES_AVEC_CODE_PRESENCE = ['BOOTCAMP'];

  showModalPresenceCode = false;
  presenceCodeActivity: any = null;
  presenceCode: PresenceCodeView | null = null;
  presenceCodeLoading = false;
  presenceCodeError: string | null = null;
  presenceCodeCopied = false;
  confirmRegenerate = false;

  constructor(
    private activityService: ActivityService,
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private location: Location,
  ) {
    this.pipe = new DatePipe('en');

    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });

    this.user = sessionStorage.getItem('user');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;

    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
      });
    }
  }

  // ===== DÉBUT AJOUT : affichage de la liste des activités en cartes =====
  trackParId(_: number, row: any): any {
    return row.id;
  }

  // Date au format "yyyy-mm-dd" pour comparer simplement (string venant du back ou Date)
  private jourIso(valeur: unknown): string {
    if (!valeur) {
      return '';
    }
    if (typeof valeur === 'string') {
      return valeur.slice(0, 10);
    }
    const d = new Date(valeur as any);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  // Statut calculé à partir des dates et de isClosed (aucun appel back)
  statutActivite(row: any): { libelle: string; classe: string } {
    if (row.isClosed) {
      return { libelle: 'Clôturée', classe: 'ga-statut--cloturee' };
    }
    const aujourdHui = this.jourIso(new Date());
    const demain = this.jourIso(new Date(Date.now() + 24 * 60 * 60 * 1000));
    const debut = this.jourIso(row.openDate);
    const fin = this.jourIso(row.closeDate) || debut;

    if (debut > aujourdHui) {
      return debut === demain
        ? { libelle: 'Demain', classe: 'ga-statut--a-venir' }
        : { libelle: 'À venir', classe: 'ga-statut--a-venir' };
    }
    if (fin < aujourdHui) {
      return { libelle: 'Terminée', classe: 'ga-statut--terminee' };
    }
    return { libelle: 'En cours', classe: 'ga-statut--en-cours' };
  }

  // Grise le bloc date des activités passées
  estPassee(row: any): boolean {
    const classe = this.statutActivite(row).classe;
    return classe === 'ga-statut--terminee' || classe === 'ga-statut--cloturee';
  }

  private readonly CLASSES_TYPE: Record<string, string> = {
    COMMERCANT_LIVREUR: 'ga-type--informelle',
    BOOTCAMP: 'ga-type--bootcamp',
    MASTERCLASS: 'ga-type--masterclass',
    WEBINAIRE: 'ga-type--webinaire',
    EVENEMENT: 'ga-type--evenement',
    ATELIER_FORCEN: 'ga-type--atelier',
    JPO: 'ga-type--jpo',
    MINIJPO: 'ga-type--jpo',
  };

  // ===== MODIF : "unknown" car activityType est typé String (objet) dans le modèle Activity =====
  classeType(type: unknown): string {
    return this.CLASSES_TYPE[String(type)] ?? 'ga-type--defaut';
  }

  // Même libellé que dans la liste déroulante "Type d'activité"
  libelleTypeActivite(type: unknown): string {
    const valeur = String(type);
    const trouve = (this.activityType as any[])?.find(
      (t) => t.value === valeur,
    );
    return trouve ? trouve.name : valeur;
  }
  // ===== FIN MODIF =====

  // Les anciennes activités sans pays sont traitées comme Sénégal
  paysActivite(row: any): string {
    return (row.country?.flag ?? 'sn').toLowerCase();
  }

  // "09:00:00" → "09:00"
  heureCourte(heure: unknown): string {
    return heure ? String(heure).slice(0, 5) : '';
  }
  // ===== FIN AJOUT =====

  ngOnInit(): void {
    this.initializeRole();
    this.activityType = ActivityType.TypesActivity;
    this.spinnerService.showSpinner();
    this.loading = true;
    //this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;

    this.initSearchListener();
    this.loadActivities();
  }

  initializeRole() {
    this.user = sessionStorage.getItem('user');
    this.role = JSON.parse(this.user)?.roles;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
        sessionStorage.setItem('nomrole', this.nomrole);
        switch (element.roleName) {
          case 'gestionnaire-finance-benin': {
            this.isFinanceBenin = true;
            break;
          }
        }
      });
    }
  }

  loadActivities() {
    this.spinnerService.showSpinner();
    this.loading = true;

    this.activityService
      .allActivityPaged(
        this.currentPage,
        this.pageSize,
        this.searchTerm,
        this.byType,
        this.fromDate,
        this.toDate,
        this.byCountry, // ← AJOUT : filtre par pays
      )
      .pipe()
      .subscribe({
        next: (response: PaginatedResponse<Activity>) => {
          if (response && response.content) {
            this.listActivity = response.content;
            this.activities = response.content;

            this.totalElements = response.totalElements || 0;
            this.totalPages = response.totalPages || 0;

            this.dataSource = new MatTableDataSource<Activity>(
              this.listActivity,
            );

            if (this.paginator) {
              this.paginator.length = this.totalElements;
              this.paginator.pageSize = this.pageSize;
              this.paginator.pageIndex = this.currentPage;

              // Désactiver la pagination locale du MatTableDataSource
              this.dataSource.paginator = null;
            }

            if (this.sort) {
              this.dataSource.sort = this.sort;
            }
          } else {
            console.error('Réponse invalide du serveur:', response);
          }

          setTimeout(() => {
            this.spinnerService.hideSpinner();
            this.loading = false;
          }, 100);
        },
        error: (err) => {
          console.error('Erreur lors du chargement des activités:', err);
          // ← MODIF : bandeau au lieu d'une alerte du navigateur (reste affiché : la liste est vide)
          this.afficherErreurListe(
            'Impossible de charger les activités. Vérifie ta connexion puis réessaie.',
            true,
          );
          this.spinnerService.hideSpinner();
          this.loading = false;
        },
      });
  }

  private initSearchListener(): void {
    this.searchSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        this.searchTerm = term;
        this.currentPage = 0;
        this.loadActivities();
      });
  }

  // Méthode pour gérer les changements de page
  onPageChange(event: any): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadActivities();
  }

  // Méthode pour changer la taille de page
  onPageSizeChange(newPageSize: number): void {
    this.pageSize = newPageSize;
    this.currentPage = 0; // Revenir à la première page
    this.loadActivities();
  }

  applyFilterBYkEY(event: Event): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLocaleLowerCase();
    //this.dataSource.filter = filter;
    this.searchSubject.next(filter);
  }

  applyFilter() {
    this.currentPage = 0;
    this.loadActivities();
  }

  reset() {
    this.currentPage = 0;
    this.searchTerm = '';
    this.filterForm.reset();
    this.loadActivities();
  }

  refreshData(): void {
    this.loadActivities();
  }

  onViewActivity(id: any) {
    //const id = arg.event._def.extendedProps.idActivity;
    this.router.navigateByUrl(`dashboard/agenda/activity-details/${id}`);
  }

  showListParticipants(id: any) {
    this.listActivity = this.activities;
    this.router.navigate([`/dashboard/agenda/participants/${id}`]);
  }

  showListConfirmation() {
    this.router.navigate(['/dashboard/agenda/participants']);
  }

  // ===== DÉBUT MODIF : popup « Détails de l'activité » en lecture seule =====
  showActivityForGes(data: any) {
    this.activity = data;
    this.showDetails = true;
    this.erreurDetails = null;
    this.lienAccesCopie = false;
    this.lieuxDetails = [];
    this.chargementLieux = false;
    // Les sessions ne sont pas dans la liste paginée : on les charge à l'ouverture
    if (this.estInformelle(data)) {
      this.chargerLieuxDetails(data.id);
    }
  }

  closeModalDetails() {
    this.showDetails = false;
    this.erreurDetails = null;
  }
  // ===== FIN MODIF =====

  // ===== DÉBUT AJOUT : ouvre le formulaire complet en mode modification =====
  modifierActivite(activity: any): void {
    this.showDetails = false;
    this.router.navigate(['/dashboard/agenda/edit-activity', activity.id]);
  }
  // ===== FIN AJOUT =====
  // ===== DÉBUT REFONTE : suppression d'une activité =====
  // À l'ouverture, le back dit ce que la suppression emporterait (sessions, invités,
  // confirmations, présences). Activité informelle avec des inscrits : suppression refusée,
  // on propose de la fermer. Autres types : le gestionnaire voit le nombre de personnes
  // concernées et décide ; s'il y a des confirmations ou des présences, il coche « je comprends ».
  suppressionEnCours = false;
  suppressionRefusee: string | null = null;
  erreurSuppression: string | null = null;
  impactSuppression: ImpactSuppression | null = null;
  chargementImpact = false;
  comprisSuppression = false;

  onDelete(activityId: number) {
    if (!activityId) {
      this.erreurDetails = "Cette activité n'a pas d'identifiant valide.";
      return;
    }
    this.activityIdToDelete = activityId;
    this.activityToDelete = this.activity;
    this.suppressionRefusee = null;
    this.erreurSuppression = null;
    this.impactSuppression = null;
    this.comprisSuppression = false;
    this.showDeleteModal = true;
    this.chargerImpactSuppression(activityId);
  }

  private chargerImpactSuppression(id: number): void {
    this.chargementImpact = true;
    this.activityService.impactSuppression(id).subscribe({
      next: (reponse: CustomResponse) => {
        if (this.activityIdToDelete !== id) {
          return; // la fenêtre a été fermée ou rouverte pour une autre activité
        }
        this.chargementImpact = false;
        const impact = reponse?.object as ImpactSuppression | null;
        this.impactSuppression = impact;
        if (impact && !impact.suppressionPossible) {
          this.suppressionRefusee =
            impact.motifRefus ?? 'Cette activité a déjà des inscrits.';
        }
      },
      error: () => {
        if (this.activityIdToDelete !== id) {
          return;
        }
        this.chargementImpact = false;
        // Le back refusera quand même si la suppression n'est pas permise
        this.erreurSuppression =
          'Impossible de vérifier qui est inscrit à cette activité. Tu peux réessayer plus tard.';
      },
    });
  }

  /** Des personnes ont confirmé ou ont été marquées présentes : il faut cocher « je comprends » */
  get confirmationRenforcee(): boolean {
    return (this.impactSuppression?.confirmesOuPresents ?? 0) > 0;
  }

  get texteImpactSessions(): string {
    const n = this.impactSuppression?.sessions ?? 0;
    return n > 1
      ? `Ses ${n} sessions seront supprimées avec elle.`
      : 'Sa session sera supprimée avec elle.';
  }

  get texteImpactPersonnes(): string {
    const impact = this.impactSuppression;
    if (!impact?.personnes) {
      return "Personne n'est invité ni inscrit.";
    }
    const personnes =
      impact.personnes > 1
        ? `${impact.personnes} personnes invitées ou inscrites`
        : '1 personne invitée ou inscrite';
    const dont = !impact.confirmesOuPresents
      ? ''
      : impact.confirmesOuPresents > 1
        ? `, dont ${impact.confirmesOuPresents} qui ont confirmé ou ont été marquées présentes`
        : ', dont 1 qui a confirmé ou a été marquée présente';
    const suite =
      impact.personnes > 1 ? 'elles seront supprimées' : 'elle sera supprimée';
    return `${personnes}${dont} : ${suite} avec l'activité.`;
  }

  get suppressionImpossibleAppel(): boolean {
    return (
      this.suppressionEnCours ||
      this.chargementImpact ||
      (this.confirmationRenforcee && !this.comprisSuppression)
    );
  }

  confirmDelete() {
    const id = this.activityIdToDelete;
    if (!id || this.suppressionImpossibleAppel) {
      return;
    }
    const nom = this.activityToDelete?.nomActivity;
    this.suppressionEnCours = true;
    this.erreurSuppression = null;

    this.activityService.deleteActivity(id).subscribe({
      next: (reponse: CustomResponse) => {
        this.suppressionEnCours = false;
        if (reponse?.status !== 200) {
          this.erreurSuppression =
            reponse?.message ||
            'La suppression a échoué. Réessaie dans un instant.';
          return;
        }
        this.closeDeleteModal();
        this.closeModalDetails();
        // Dernière activité de la page : on revient à la page précédente
        if (this.listActivity?.length === 1 && this.currentPage > 0) {
          this.currentPage--;
        }
        this.loadActivities(); // garde la recherche, les filtres et la page
        this.afficherSuccesListe(`L'activité « ${nom} » a été supprimée.`);
      },
      error: (err) => {
        this.suppressionEnCours = false;
        if (err?.status === 409) {
          // Quelqu'un s'est inscrit entre la vérification et la suppression
          this.suppressionRefusee =
            err?.error?.message ?? 'Cette activité a déjà des inscrits.';
        } else {
          this.erreurSuppression =
            err?.error?.message ??
            'La suppression a échoué. Réessaie dans un instant.';
        }
      },
    });
  }

  /** Suppression refusée : on ferme l'activité à la place (comme le cadenas) */
  fermerActiviteApresRefus(): void {
    const row = this.activityToDelete;
    if (!row || row.isClosed || this.suppressionEnCours) {
      return;
    }
    this.suppressionEnCours = true;
    this.erreurSuppression = null;

    const payload = { isClosed: true } as Activity;
    this.activityService.updateActivity(payload, String(row.id)).subscribe({
      next: () => {
        row.isClosed = true; // la carte de la liste se met à jour
        this.suppressionEnCours = false;
        this.closeDeleteModal();
        this.closeModalDetails();
        this.afficherSuccesListe(
          `L'activité « ${row.nomActivity} » est fermée : plus personne ne peut s'inscrire, et l'historique est conservé.`,
        );
      },
      error: (err) => {
        this.suppressionEnCours = false;
        this.erreurSuppression =
          err?.error?.message ??
          "Impossible de fermer l'activité. Réessaie dans un instant.";
      },
    });
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.activityIdToDelete = null;
    this.activityToDelete = null;
    this.suppressionRefusee = null;
    this.erreurSuppression = null;
    this.impactSuppression = null;
    this.chargementImpact = false;
    this.comprisSuppression = false;
  }
  // ===== FIN REFONTE =====

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'OUTILS' },
    { label: 'GESTION DES ACTIVITÉS', url: '/dashboard/agenda' },
  ];

  showPopupForQRCode(data: any) {
    this.showModalQRCode = true;
    this.rowDATA = data;
    // console.log('data : ', data);
  }
  closeQRCoceModal() {
    this.showModalQRCode = false;
  }

  copyFormLink(row: any): void {
    const path = this.router.serializeUrl(
      this.router.createUrlTree([
        '/activity',
        row.id,
        'formationcom',
        'inscription',
      ]),
    );

    const externalUrl = this.location.prepareExternalUrl(path);

    // baseURI se termine déjà par "/", externalUrl commence par "/" -> on évite le double slash
    const base = document.baseURI.replace(/\/$/, '');
    const link = `${base}${externalUrl}`;

    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.copiedRowId = row.id;
        setTimeout(() => (this.copiedRowId = null), 2000);
      })
      .catch((err) => {
        console.error('Erreur lors de la copie du lien', err);
      });
  }
  openUrl(url: string) {
    window.open(url, '_blank');
  }

  // ===== DÉBUT AJOUT : bandeau d'erreur de la liste =====
  /** persistante = true : le message reste jusqu'à ce qu'on le ferme */
  afficherErreurListe(message: string, persistante = false): void {
    this.fermerSuccesListe(); // ← AJOUT : un seul bandeau à la fois
    clearTimeout(this.erreurListeTimer);
    this.erreurListe = message;
    if (!persistante) {
      this.erreurListeTimer = setTimeout(() => (this.erreurListe = null), 8000);
    }
  }

  fermerErreurListe(): void {
    clearTimeout(this.erreurListeTimer);
    this.erreurListe = null;
  }

  // ===== AJOUT : bandeau de succès (5 s) =====
  afficherSuccesListe(message: string): void {
    this.fermerErreurListe();
    clearTimeout(this.succesListeTimer);
    this.succesListe = message;
    this.succesListeTimer = setTimeout(() => (this.succesListe = null), 5000);
  }

  fermerSuccesListe(): void {
    clearTimeout(this.succesListeTimer);
    this.succesListe = null;
  }
  // ===== FIN AJOUT =====

  openClosureModal(row: any): void {
    this.activityToToggle = row;
    this.showModalClosure = true;
  }

  closeClosureModal(): void {
    this.showModalClosure = false;
    this.activityToToggle = null;
  }

  confirmToggleActivityClosure(): void {
    if (!this.activityToToggle) return;

    const row = this.activityToToggle;
    const newState = !row.isClosed;
    row.isClosed = newState;
    this.closeClosureModal();

    const payload = { isClosed: newState } as Activity;

    this.activityService.updateActivity(payload, String(row.id)).subscribe({
      next: () => {},
      error: (err) => {
        row.isClosed = !newState;
        console.error("Erreur lors de la mise à jour de l'activité :", err);
        // ← MODIF : l'erreur est enfin visible
        this.afficherErreurListe(
          err?.error?.message ??
            `Impossible de ${newState ? 'fermer' : 'rouvrir'} l'activité « ${row.nomActivity} ». Réessaie dans un instant.`,
        );
      },
    });
  }

  // ===== DÉBUT AJOUT : popup « Détails de l'activité » =====
  lieuxDetails: LieuDTO[] = [];
  chargementLieux = false;
  erreurDetails: string | null = null;
  lienAccesCopie = false;

  estInformelle(activite: any): boolean {
    return String(activite?.activityType) === 'COMMERCANT_LIVREUR';
  }

  /** Atelier Force-N : réservé à l'admin (même règle qu'avant pour Modifier et Supprimer) */
  peutModifier(activite: any): boolean {
    return (
      String(activite?.activityType) !== 'ATELIER_FORCEN' ||
      this.nomrole === 'admin'
    );
  }

  /** Public en clair ; null pour les types sans public (JPO, Mini JPO, Masterclass…) */
  publicActivite(activite: any): { titre: string; detail?: string } | null {
    const type = String(activite?.activityType);
    if (type === 'COMMERCANT_LIVREUR') {
      return {
        titre: 'Inscription libre par le formulaire',
        detail: 'Commerçants et livreurs',
      };
    }
    if (type === 'ATELIER_FORCEN') {
      return { titre: 'Personnel Force-N', detail: 'Choisi à la création' };
    }
    if (!['EVENEMENT', 'WEBINAIRE', 'BOOTCAMP'].includes(type)) {
      return null;
    }
    if (activite.isPublic) {
      return { titre: 'Tous les apprenants' };
    }
    const zones: string[] = (activite.residenceZones ?? [])
      .map((z: any) => (typeof z === 'string' ? z : (z?.name ?? z?.libelle)))
      .filter(Boolean);
    if (zones.length) {
      return { titre: 'Par zone de résidence', detail: zones.join(', ') };
    }
    const nbCertificats = activite.listIdCertificats?.length ?? 0;
    if (activite.nomCertif || nbCertificats) {
      return {
        titre: 'Par certificat',
        detail:
          activite.nomCertif ||
          `${nbCertificats} certificat${nbCertificats > 1 ? 's' : ''}`,
      };
    }
    return { titre: 'À définir', detail: "Aucun participant pour l'instant" };
  }

  /** "google.com" → "https://google.com" : sinon le lien s'ouvre dans l'application */
  lienAbsolu(url: string): string {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  }

  copierLienAcces(url: string): void {
    navigator.clipboard.writeText(this.lienAbsolu(url)).then(() => {
      this.lienAccesCopie = true;
      setTimeout(() => (this.lienAccesCopie = false), 2000);
    });
  }

  nbCreneauxLieu(lieu: LieuDTO): number {
    return lieu.jours.reduce((t, j) => t + j.creneaux.length, 0);
  }

  get resumeLieuxDetails(): string {
    const villes = this.lieuxDetails.length;
    const jours = this.lieuxDetails.reduce((t, l) => t + l.jours.length, 0);
    const creneaux = this.lieuxDetails.reduce(
      (t, l) => t + this.nbCreneauxLieu(l),
      0,
    );
    return (
      `${villes} ville${villes > 1 ? 's' : ''} · ` +
      `${jours} jour${jours > 1 ? 's' : ''} · ` +
      `${creneaux} créneau${creneaux > 1 ? 'x' : ''}`
    );
  }

  private chargerLieuxDetails(id: number): void {
    this.chargementLieux = true;
    this.activityService.getActivityByIdV2(id).subscribe({
      next: (reponse: CustomResponse) => {
        if (this.activity?.id !== id) {
          return; // une autre activité a été ouverte entre-temps
        }
        this.chargementLieux = false;
        this.lieuxDetails =
          (reponse?.object as ActivityResponse | null)?.lieux ?? [];
      },
      error: () => {
        if (this.activity?.id !== id) {
          return;
        }
        this.chargementLieux = false;
        this.erreurDetails =
          'Impossible de charger les sessions de cette activité.';
      },
    });
  }

  /** Échap ferme la confirmation de suppression, puis la popup des détails */
  @HostListener('document:keydown.escape')
  fermerAvecEchap(): void {
    if (this.showDeleteModal) {
      this.closeDeleteModal();
    } else if (this.showDetails) {
      this.closeModalDetails();
    }
  }
  // ===== FIN AJOUT =====

  // ===== Code de présence =====
  // Doit rester aligné avec TYPES_WITH_PRESENCE_CODE dans PresenceCodeService (back)

  aCodePresence(row: any): boolean {
    return this.TYPES_AVEC_CODE_PRESENCE.includes(String(row?.activityType));
  }

  openPresenceCodeModal(row: any): void {
    this.presenceCodeActivity = row;
    this.presenceCode = null;
    this.presenceCodeError = null;
    this.confirmRegenerate = false;
    this.showModalPresenceCode = true;
    this.loadPresenceCode();
  }

  closePresenceCodeModal(): void {
    this.showModalPresenceCode = false;
    this.presenceCodeActivity = null;
    this.presenceCode = null;
    this.confirmRegenerate = false;
  }

  private loadPresenceCode(): void {
    this.presenceCodeLoading = true;
    this.activityService
      .getPresenceCode(this.presenceCodeActivity.id)
      .subscribe({
        next: (response: CustomResponse) => {
          this.presenceCode = response.object as PresenceCodeView;
          this.presenceCodeLoading = false;
        },
        error: (err) => {
          this.presenceCodeError =
            err?.error?.message ??
            'Impossible de récupérer le code de présence.';
          this.presenceCodeLoading = false;
        },
      });
  }

  regeneratePresenceCode(): void {
    // Premier clic : on demande confirmation. Second clic : on régénère.
    if (!this.confirmRegenerate) {
      this.confirmRegenerate = true;
      return;
    }
    this.confirmRegenerate = false;
    this.presenceCodeLoading = true;
    this.presenceCodeError = null;

    this.activityService
      .regeneratePresenceCode(this.presenceCodeActivity.id)
      .subscribe({
        next: (response: CustomResponse) => {
          this.presenceCode = response.object as PresenceCodeView;
          this.presenceCodeLoading = false;
        },
        error: (err) => {
          this.presenceCodeError =
            err?.error?.message ??
            'Impossible de régénérer le code de présence.';
          this.presenceCodeLoading = false;
        },
      });
  }

  copyPresenceCode(): void {
    if (!this.presenceCode?.code) {
      return;
    }
    navigator.clipboard.writeText(this.presenceCode.code).then(() => {
      this.presenceCodeCopied = true;
      setTimeout(() => (this.presenceCodeCopied = false), 2000);
    });
  }
}
